const state = {
    data: {},
    edited: {},
    editInfoId: null,
    onEdit: {},
    raw: null,
};

const mutations = {
    landing_banners_init_raw(state, payload) {
        state.raw = payload;
    },

    landing_banners_init(state, payload) {
        state.data = payload;
    },

    landing_banners_edited(state, payload) {
        state.edited = payload;
    },

    landing_banners_onedit(state, payload) {
        state.editInfoId = payload.id;
        state.onEdit = payload;
    },

    landing_banners_clear(state) {
        state.data = {};
        state.edited = {};
        state.editInfoId = null;
        state.onEdit = {};
        state.raw = null;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/global/stores/landing_banners.js